import React, { useState, useEffect } from "react";
import { graphql, createPaginationContainer } from "react-relay";
import "./PostView.css";
import { timeDifferenceForDate } from "../utils";
import { ITEMS_PER_PAGE } from "../constants";
import { useNavigate } from "react-router-dom";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import PopupMenu from "../components/PopupMenu";
import DetailViewModal from "../components/DetailViewModal";
import { useTheme } from "../contexts/ThemeContext";
import BookmarkMagazine from "./BookmarkMagazine";
// import DetailViewWrapper from "../DetailViewWrapper";

// import { SearchModal } from "../components/Modal";

function BookmarkView(props) {
    const [articleMenuActive, setArticleMenuActive] = useState(false);
    const [isDetailView, setIsDetailView] = useState(false);
    const navigate = useNavigate();
    const [postTitle, setPostTitle] = useState("");
    const [postBody, setPostBody] = useState("");
    const [postId, setPostId] = useState("");
    const [postLink, setPostLink] = useState("");
    const [postImageURL, setPostImageURL] = useState("");
    const [postBodyHtml, setPostBodyHtml] = useState("");
    const [isDetailModalActive, setIsDetailModalActive] = useState(false);
    const [postCreated, setPostCreated] = useState("");
    const [sourceName, setSourceName] = useState("");
    const theme = useTheme();

    const { bookmarks } = props.home_Feeds;
    const user = props.user;
    const settings = props.settings;

    // 	const postArr = selectedPosts.edges;
    // 	const bookmarksArr = bookmarks.edges;

    // 	// console.log(bookmarksArr);
    // 	// console.log(postArr);

    // 	for (var i = 0; i < bookmarksArr.length; i++) {
    // 		for (var j = 0; j < postArr.length; j++) {
    // 			if (bookmarksArr[i].node.post.id == postArr[j].node.id) {
    // 				console.log(bookmarksArr[i].node.post.title);
    // 			}
    // 		}
    // 	}

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    function _loadMore() {
        if (!props.relay.hasMore()) {
            return;
        } else if (props.relay.isLoading()) {
            return;
        }
        props.relay.loadMore(ITEMS_PER_PAGE);
    }

    const handleScroll = (e) => {
        e.preventDefault();

        if (
            window.innerHeight + document.documentElement.scrollTop ===
            document.documentElement.offsetHeight
        ) {
            _loadMore();
        }
    };

    function setSeletedPost(id) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(id, "selectedPostId");
        });
    }

    function onHeadlineClick(e) {
        e.preventDefault();
        // setIsDetailView(true);

        setIsDetailModalActive(true);
        setPostBody(e.target.dataset.body);
        setPostTitle(e.target.dataset.title);
        setPostLink(e.target.dataset.link);
        setPostId(e.target.dataset.postid);
        setPostImageURL(e.target.dataset.img);
        setPostBodyHtml(e.target.dataset.html);
        setPostCreated(e.target.dataset.created);
        setSourceName(e.target.dataset.source);

        let scroll = window.scrollY;

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(scroll.toString(), "scrollPosition");
        });

        // router.push("/home/detail-view");
        setSeletedPost(e.target.dataset.id);
    }

    function onDetailViewClick(e) {
        setIsDetailView(false);
    }

    useEffect(() => {
        // console.log(articleMenuActive);
    });

    return (
        <div
            id={`news-container news-container-${isDetailView}`}
            className="news-container"
        >
            {isDetailModalActive ? (
                <div>
                    <DetailViewModal
                        title=""
                        isModalActive={isDetailModalActive}
                        setIsModalActive={setIsDetailModalActive}
                        isDetailView={false}
                        postId={postId}
                        postLink={postLink}
                        postTitle={postTitle}
                        postBody={postBody}
                        postBodyHtml={postBodyHtml}
                        postImageURL={postImageURL}
                        postCreated={postCreated}
                        sourceName={sourceName}
                        user={user}
                        settings={settings}
                    />
                </div>
            ) : null}
            <BookmarkMagazine
                bookmarks={bookmarks}
                onHeadlineClick={onHeadlineClick}
                user={user}
                settings={settings}
                articleMenuActive={articleMenuActive}
            />
        </div>
    );
}

export default createPaginationContainer(
    BookmarkView,
    {
        home_Feeds: graphql`
            fragment BookmarkView_home_Feeds on Query {
                bookmarks(
                    first: $count
                    after: $after
                    orderBy: $orderBy
                    filterTerms: $filterTerms
                ) @connection(key: "BookmarkView_bookmarks") {
                    edges {
                        node {
                            id
                            post {
                                id
                                title
                                body
                                body_html
                                body_short
                                link
                                created
                                image_url
                                source {
                                    id
                                    name
                                    edited_name
                                }
                            }
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        `,
    },
    {
        direction: "forward",
        query: graphql`
            query BookmarkViewForwardQuery(
                $orderBy: [String]
                $count: Int!
                $after: String
                $filterTerms: [String]
            ) {
                ...BookmarkView_home_Feeds
            }
        `,
        getConnectionFromProps(props) {
            return props.home_Feeds && props.home_Feeds.bookmarks;
        },
        getFragmentVariables(previousVariables, totalCount) {
            return {
                ...previousVariables,
                count: totalCount,
            };
        },
        getVariables(props, paginationInfo, fragmentVariables) {
            return {
                count: paginationInfo.count,
                after: paginationInfo.cursor,
                orderBy: fragmentVariables.orderBy,
                filterTerms: fragmentVariables.filterTerms,
            };
        },
    }
);
